import { CustomerOptions } from '@amzn/journeys-common';

export const detailPageCustomerOptions = [
  {
    text: 'All',
    value: CustomerOptions.All,
  },
  {
    text: 'Recognized',
    value: CustomerOptions.Recognized,
  },
  {
    text: 'Unrecognized',
    value: CustomerOptions.Unrecognized,
  },
];

export const gatewayCustomerOptions = [
  {
    text: 'Recognized',
    value: CustomerOptions.Recognized,
  },
  {
    text: 'Unrecognized',
    value: CustomerOptions.Unrecognized,
  },
  {
    text: 'Recognized and Unrecognized (create both)',
    value: CustomerOptions.RecognizedAndUnrecognized,
  },
];
